import { render, staticRenderFns } from "./CategoryDoughnutChart.vue?vue&type=template&id=0625c97f&scoped=true&"
import script from "./CategoryDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./CategoryDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDoughnutChart.vue?vue&type=style&index=0&id=0625c97f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0625c97f",
  null
  
)

export default component.exports